import { Card, CardContent, CardHeader, CardTitle } from "../../../Components/UI/card";
import { Plus } from "lucide-react";

const CustomizableCard = ({
  title,
  icon,
  iconColor = "text-gray-500",
  sections = [],
  onAddClick,
  showAddButton = false,
  addButtonColor = "text-sahi-primary-color",
  cardClassName = "",
  headerClassName = "",
  contentClassName = "",
  mobileLayout = false,
  gridCols = 3,
}) => {
  const defaultCardClass = "transition-all duration-300 bg-sahi-white md:border md:border-sahi-border-color md:shadow-md md:rounded-xl border-none shadow-none";
  const finalCardClass = cardClassName || defaultCardClass;

  const gridColsClass = {
    1: "grid-cols-1",
    2: "grid-cols-2", 
    3: "grid-cols-3",
    4: "grid-cols-4",
    5: "grid-cols-5",
    6: "grid-cols-6"
  };

  // Determine mobile layout based on number of sections
  const getMobileLayout = () => {
    if (sections.length <= 3) {
      return "flex justify-between gap-4";
    } else if (sections.length === 4) {
      return "grid grid-cols-2 gap-3";
    } else {
      return "flex gap-3 overflow-x-auto";
    }
  };

  const getMobileItemClass = () => {
    if (sections.length <= 3) {
      return "flex-1 min-w-0";
    } else if (sections.length === 4) {
      return ""; // Grid items don't need flex classes
    } else {
      return "flex-shrink-0 min-w-[80px]";
    }
  };

  return (
    <Card className={finalCardClass}>
      {/* Desktop Header - hidden on mobile */}
      <CardHeader className={`sm:pb-3 sm:pt-0 pt-3 hidden md:block ${headerClassName}`}>
        <CardTitle className="flex items-center gap-2 text-lg">
          {icon && <span className={iconColor}>{icon}</span>}
          <span className="text-text-color">{title}</span>
          {showAddButton && onAddClick && (
            <div
              className={`ml-auto p-1 ${addButtonColor} hover:cursor-pointer hover:bg-sahi-blue-light sahi-radius duration-200`}
              onClick={onAddClick}
            >
              <Plus className="h-6 w-6" />
            </div>
          )}
        </CardTitle>
      </CardHeader>

      {/* Mobile Header with horizontal layout */}
      <div className="md:hidden flex items-center justify-between px-4">
        <div className="flex items-center gap-2">
          {icon && <span className={iconColor}>{icon}</span>}
          <span className="text-text-color font-semibold">{title}</span>
        </div>
        {/* {showAddButton && onAddClick && (
          <div
            className={`p-1 ${addButtonColor} hover:cursor-pointer hover:bg-sahi-blue-light sahi-radius duration-200`}
            onClick={onAddClick}
          >
            <Plus className="h-5 w-5" />
          </div>
        )} */}
      </div>

      <CardContent className={`md:pb-6 md:px-6 px-4 pb-3 ${contentClassName}`}>
        {/* Desktop Layout - configurable grid */}
        <div className={`hidden md:grid ${gridColsClass[gridCols] || 'grid-cols-3'} gap-4 text-center`}>
          {sections.map((section, index) => (
            <div 
              key={index}
              onClick={section.onClick && !section.disabled ? section.onClick : undefined}
              className={`${section.onClick && !section.disabled ? 'cursor-pointer' : ''} ${section.disabled ? 'opacity-50' : ''}`}
            >
              <div className={`text-3xl sm:text-4xl lg:text-5xl font-bold ${section.color || 'text-gray-500'}`}>
                {section.value}
              </div>
              <div className="text-sm mt-2 text-sub-text-color">
                {section.label}
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Layout - responsive based on number of sections */}
        <div className={`md:hidden ${getMobileLayout()}`}>
          {sections.map((section, index) => (
            <div 
              key={index}
              onClick={section.onClick && !section.disabled ? section.onClick : undefined}
              className={`cursor-pointer ${getMobileItemClass()} ${section.bgColor || 'bg-bg-grey'} rounded-lg p-3 text-center ${section.disabled ? 'opacity-50' : ''}`}
            >
              <div className={`text-2xl sm:text-3xl font-bold ${section.color || 'text-gray-500'}`}>
                {section.value}
              </div>
              <div className="text-xs sm:text-sm mt-1 text-sub-text-color">
                {section.label}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default CustomizableCard;